import '../changePassword/changePassword.css'
import React, { useContext, useState } from 'react'
import { AppContext } from '../../App'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Side from '../side/Side';

const ChangePocket = () => {
    const {route,setLoader}=useContext(AppContext)
    const [old,setOld]=useState("")
    const [newP,setNewP]=useState("")
    const [rNew,setRnew]=useState("")

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoader(true)
        try {
          const response = await fetch(`${route}/acc/chnageBucketPassword`, {
            method: 'PUT',
            headers:{
                'Content-Type': 'application/json',
                "Authorization" :`Bearer ${sessionStorage.getItem("token")}`
            },
            body: JSON.stringify({
                current_bocket_password : old, 
                new_bocket_password :newP,
                bocket_password_confirmation : rNew
            })
          })
          .then(res=>res.json())
          console.log(response)
          setLoader(false)
          if(response.status === 'success'){
            toast.success(response.msg)
          }
        if(response.status === "faild"){
toast.error(response.msg)
        }
        if (response.errors.bocket_password_confirmation){
            toast.error(response.errors.bocket_password_confirmation[0])
        }
        if (response.errors.bocket_password){
            toast.error(response.errors.bocket_password)
        }
        
    
         
        } catch (error) {
          console.error(error);
        
        }
      };


  return (
    <div className="pocket">
        <div className="container">
            <h2>تغيير كلمة مرور الخزنة</h2>
            {/* <form action="" onSubmit={handleSubmit}>
                <input onChange={(e)=>setOld(e.target.value)} type="text" placeholder='أدخل كلمة السر' />
                <input onChange={(e)=>setNewP(e.target.value)} type="text"placeholder='أدخل كلمة السر الجديدة' />
                <input onChange={(e)=>setRnew(e.target.value)} type="text" placeholder='أعد ادخال كلمة السر الجديدة'/>
                <button type='submit'>تغيير</button>
            </form> */}

            <form className="form-card" onSubmit={handleSubmit}>
  <div className="field">
    <label>كلمة المرور الحالية</label>
    <input
      type="password"
      onChange={(e) => setOld(e.target.value)}
      placeholder="أدخل كلمة المرور الحالية"
    />
  </div>

  <div className="field">
    <label>كلمة المرور الجديدة</label>
    <input
      type="password"
      onChange={(e) => setNewP(e.target.value)}
      placeholder="أدخل كلمة المرور الجديدة"
    />
  </div>

  <div className="field">
    <label>تأكيد كلمة المرور</label>
    <input
      type="password"
      onChange={(e) => setRnew(e.target.value)}
      placeholder="أعد إدخال كلمة المرور"
    />
  </div>

  <button className="submit-btn">تغيير كلمة المرور</button>
</form>

        </div>
        <Side />
    </div>
  )
}

export default ChangePocket
